const header = function() {
  let user = JSON.parse(localStorage.getItem('user'))

  if (!user) return {}

  return {
    headers: {
      Authorization: 'Bearer ' + user.token
    }
  }
};

export const headerToken = (token) => {
   if (token) return {
      headers: {
         Authorization: 'Bearer ' + token
      }
   }

}

export default header();
